

const VisionPro = ({ className })=> (
  <svg className={className} viewBox="0 0 256 256">
  <rect width="256" height="256" fill="none" rx="60" />
  <path d="M176.000 74.667C202.667 80.000 224.000 96.157 224.000 122.667V133.333C224.000 159.843 202.510 181.333 176.000 181.333C149.490 181.333 148.513 160.000 128.000 160.000C107.487 160.000 106.510 181.333 80.000 181.333C53.490 181.333 32.000 159.843 32.000 133.333V122.667C32.000 96.157 53.333 80.000 80.000 74.667C106.667 69.333 128.000 69.333 128.000 69.333C128.000 69.333 149.333 69.333 176.000 74.667Z" stroke="#fcfcfc" stroke-width="14" transform="translate(25.599999999999994,25.066599273681636) scale(0.8)" />
</svg>
)

export default VisionPro